import React from "react";
import { ReportsTable } from "components/table/reports/ReportsTable";

const Reports = () => {
    return (
         <>
            <ReportsTable />
         </>
    );
}

export { Reports };